<template>
  <div class="section-divider">
    <span></span>
  </div>
</template>
